<section style="overflow-y: scroll;height: 390px;">

  <div>
      <div class="wrapper">
      <div class="styled-input">
      <button type="button" class="add-boutton" style="left: 83%;" name="Add" (click)="Save_MedicalHistory()">Update</button>
      </div>
      </div>
  </div>
      <div class="appointment-form-field">
      <table style="width: 100%;">
        <tr>
          <td style="width: 25%;"><label style="width: 35%;"><input type="checkbox" [(ngModel)]= "diabetescheck" style="width: 20px;height: 20px;">Diabetes</label></td>
          <td style="width: 40%;" colspan ="2">
            <textarea rows = "2" cols = "30" name = "diabetescontrol" [(ngModel)]= "diabetescontrol" class="appointment-form-field" style="width: 100%;height: 100%;" maxlength="200ch"> Enter details here... </textarea><br>
          </td>

        <tr>
          <td style="width: 25%;"><label style="width: 35%;;"><input type="checkbox" [(ngModel)]="haypercheck" style="width: 20px;height: 20px;">Hypertension</label></td>
           <td style="width: 40%;" colspan ="2">
            <textarea rows = "2" cols = "30" name = "HayperControl" [(ngModel)]= "haypercontrol" class="appointment-form-field" style="width: 100%;height: 100%;" maxlength="200ch"> Enter details here... </textarea><br>
          </td>

        <tr>
        </tr>
        <tr>
          <td style="width: 25%;"><label style="width: 35%;; "><input type="checkbox" [(ngModel)]="hepacheck" style="width: 20px;height: 20px;">Hepatitis C</label></td>
            <td style="width: 40%;" colspan ="2">
            <textarea rows = "2" cols = "30" name = "hepacheck" [(ngModel)]= "hepacontrol" class="appointment-form-field" style="width: 100%;height: 100%;" maxlength="200ch"> Enter details here... </textarea><br>
          </td>
        </tr>
        <tr>
          <td style="width: 25%;"><label style="width: 35%;;  "><input type="checkbox" [(ngModel)]="bilhcheck" style="width: 20px;height: 20px;">Ischemic heart</label></td>
          <td style="width: 40%;" colspan ="2">
            <textarea rows = "2" cols = "30" name = "bilhcheck" [(ngModel)]= "bilhcontrol" class="appointment-form-field" style="width: 100%;height: 100%;" maxlength="200ch"> Enter details here... </textarea><br>
          </td>
        </tr>
        <tr>
          <td style="width: 25%;"><label style="width: 35%; "><input type="checkbox" [(ngModel)]="cardcheck" style="width: 20px;height: 20px;">Cardiomyopathy</label></td>
          <td style="width: 40%;" colspan ="2">
            <textarea rows = "2" cols = "30" name = "cardcheck" [(ngModel)]= "cardcontrol" class="appointment-form-field" style="width: 100%;height: 100%;"  maxlength="200ch"> Enter details here... </textarea><br>
          </td>
        </tr>

        <tr>
          <td style="width: 25%;"><label style="width: 35%; ">
            <input type="checkbox" [(ngModel)]= "othersMcheck" style="width: 20px;height: 20px;">Others</label>
          </td>
          <td style="width: 40%;" colspan ="2">
            <textarea rows = "2" cols = "30" name = "otherscontrol" [(ngModel)]= "otherscontrol" class="appointment-form-field" style="width: 100%;height: 100%;"  maxlength="200ch"> Enter details here... </textarea><br>
          </td>

      </table>
    </div>



  </section>


